import React, { useContext, useEffect, useState } from "react";
import "./Right_End_Toolbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import Buy_sell_Btns from "./buy_sell_btns/Buy_sell_Btns";
import { Context } from "../../../../utils/context";
import {
  GetAllBuyAndSellPending,
  postBuyAndSell,
  postBuyAndSellPending,
} from "../../../../utils/apis/buy_and_sell/buy_and_sell";
import { useNavigate } from "react-router-dom";
import { getData } from "../../../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Right_End_Toolbar = ({
  onClose,
  latestAmount,
  price,
  companyId,
  companyName,
  setPrice,
  getGraphData,
  openSuccess,
  openSuccessClose,
  isMobile = false,
  handlePageChange = () => {},
}) => {
  const { buyOrSale, getuserData, userdata, signin, appSetUpData } = useContext(Context);

  const [appSetUp, setAppSetUp] = useState({});
  const [activeBtn, setActiveBtn] = useState("Market");
  const [quantity, setQuantity] = useState(1.0); // Now decimal
  const [targetPrice, setTargetPrice] = useState("");
  const [tradeError, setTradeError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allPendingtrade, setAllPendingTrade] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const getAppsetUpData = async () => {
      const response = await getData(`/common/masters/app-setup`);
      if (response?.data) setAppSetUp(response.data);
    };
    getAppsetUpData();
    setPrice(latestAmount);
  }, [latestAmount, setPrice]);

  // Fetch pending trades
  const getPending = async () => {
    if (!companyId) return;
    const res = await GetAllBuyAndSellPending(companyId);
    if (res?.success) setAllPendingTrade(res.data || []);
  };

  useEffect(() => {
    if (signin && companyId) getPending();
  }, [companyId, signin]);

  // Quantity controls (now support decimals)
  const handleIncrement = () => {
    setQuantity((prev) => Math.max((prev || 0) + 1, 1));
  };

  const handleDecrement = () => {
    setQuantity((prev) => Math.max((prev || 0) - 1, 1));
  };

  // Market Order
  const submitMarket = async () => {
    if (!buyOrSale) {
      setTradeError("Please select Buy or Sell");
      toast.error("Please select Buy or Sell", { position: "bottom-right" });
      return;
    }

    if (quantity < 0.01) {
      setTradeError("Minimum quantity is 0.01");
      toast.error("Minimum quantity is 0.01", { position: "bottom-right" });
      return;
    }

    setIsLoading(true);
    const payload = {
      amount: Number(latestAmount) * quantity,
      company_id: companyId,
      quantity: quantity,
      type: buyOrSale,
    };

    try {
      const res = await postBuyAndSell(payload);
      if (res?.success) {
        toast.success(`Successfully opened ${quantity.toFixed(2)} lot(s)`, {
          position: "bottom-right",
          autoClose: 5000,
          theme: "dark",
        });

        getGraphData?.();
        handlePageChange?.();
        setQuantity(1.0);
        getuserData?.(userdata?.id);
        // openSuccess?.();
        // setTimeout(() => openSuccessClose?.(), 3000);
        if (isMobile) setTimeout(onClose, 3000);
      } else {
        const msg = res?.message || "Transaction failed";
        setTradeError(msg);
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (err) {
      setTradeError("Network error. Please try again.");
      toast.error("Network error occurred", { position: "bottom-right" });
    } finally {
      setIsLoading(false);
    }
  };

  // Pending Order
  const submitPendingOrder = async () => {
    if (!buyOrSale) {
      setTradeError("Please select Buy or Sell");
      toast.error("Please select Buy or Sell", { position: "bottom-right" });
      return;
    }

    if (!targetPrice || Number(targetPrice) <= 0) {
      setTradeError("Enter a valid limit price");
      toast.error("Enter a valid limit price", { position: "bottom-right" });
      return;
    }

    if (quantity < 0.01) {
      setTradeError("Minimum quantity is 0.01");
      toast.error("Minimum quantity is 0.01", { position: "bottom-right" });
      return;
    }

    setIsLoading(true);
    const totalAmount = Number(targetPrice) * quantity * (1 + (appSetUpData?.platform_percent || 0) / 100);

    const payload = {
      amount: totalAmount,
      company_id: companyId,
      quantity: quantity,
      type: buyOrSale,
    };

    try {
      const res = await postBuyAndSellPending(payload);
      if (res?.success) {
        toast.success(`Pending order placed for ${quantity.toFixed(2)} lot(s)`, {
          position: "bottom-right",
          autoClose: 5000,
          theme: "dark",
        });

        getPending();
        setTargetPrice("");
        setQuantity(1.0);
        // openSuccess?.();
        // setTimeout(openSuccessClose, 3000);
        if (isMobile) setTimeout(onClose, 3000);
      } else {
        const msg = res?.message || "Failed to place pending order";
        setTradeError(msg);
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (err) {
      setTradeError("Network error");
      toast.error("Network error occurred", { position: "bottom-right" });
    } finally {
      setIsLoading(false);
    }
  };

  // Amount calculations (supports decimals)
  const currentPrice = activeBtn === "Pending" ? Number(targetPrice || latestAmount) : latestAmount;
  const subtotal = currentPrice * quantity;
  const fee = subtotal * (appSetUpData?.platform_percent || 0) / 100;
  const total = subtotal + fee;

  return (
    <div className="right-toolbar-container bg-gray-900 flex flex-col h-full">
      <ToastContainer position="bottom-right" theme="dark" />
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-6 max-md:py-1 border-b border-gray-800">
        <h2 className="text-2xl font-bold text-white">{companyName}</h2>
        {isMobile && (
          <button
            onClick={onClose}
            className="w-12 h-12 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
          >
            {/* <FontAwesomeIcon icon={faXmark} className="text-2xl text-gray-400" /> */}
          </button>
        )}
      </div>

      {/* Buy/Sell Buttons */}
      <Buy_sell_Btns
        latestAmount={latestAmount}
        setPrice={setPrice}
        price={price}
        sellOnClick={() => setTradeError("")}
        BuyOnClick={() => setTradeError("")}
      />

      {/* Market / Pending Tabs */}
      <div className="flex border-b border-gray-800 mx-6 mt-8 max-md:mt-0">
        {["Market", "Pending"].map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setActiveBtn(tab);
              setTradeError("");
              if (tab === "Market") setTargetPrice("");
            }}
            className={`flex-1 py-4 font-medium text-lg transition-all duration-300
              ${activeBtn === tab 
                ? "text-white border-b-4 border-blue-500" 
                : "text-gray-500 hover:text-white"}
            `}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Pending Target Price */}
      {activeBtn === "Pending" && (
        <div className="px-6 mt-8 ">
          <label className="text-gray-400 text-sm font-medium block mb-3">Target Execution Price</label>
          <input
            type="number"
            value={targetPrice}
            onChange={(e) => setTargetPrice(e.target.value)}
            placeholder="Enter Limit price"
            step="0.01"
            min="0.01"
            className="w-full px-5 py-4 max-md:py-0 max-md:scale-[.8] max-md:-mt-3 bg-gray-800 border border-gray-700 rounded-xl text-white text-lg focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 transition-all"
          />
        </div>
      )}

      {/* Volume Selector - Decimal input + buttons */}
      <div className="px-6 mt-8 max-md:mt-4">
        <label className="text-gray-400 text-sm font-medium block mb-4">Volume (Lots)</label>
        <div className="flex items-center max-md:h-[10%] max-md:scale-[.8] max-md:-mt-5 justify-center space-x-4 bg-gray-800 rounded-xl p-5 border border-gray-700">
          <button
            onClick={handleDecrement}
            className="w-14 h-14 max-md:w-10 max-md:h-8 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center transition-all hover:scale-110"
            disabled={quantity <= 0.1}
          >
            <FontAwesomeIcon icon={faMinus} className="text-xl text-white" />
          </button>

          <input
            type="number"
            value={quantity}
            onChange={(e) => {
              const val = parseFloat(e.target.value);
              if (!isNaN(val) && val >= 0) {
                setQuantity(val);
              } else if (e.target.value === "") {
                setQuantity("");
              }
            }}
            onBlur={(e) => {
              const val = parseFloat(e.target.value);
              if (!isNaN(val)) {
                setQuantity(Math.max(val, 0.01));
              }
            }}
            min="0.01"
            step="0.01"
            placeholder="0.01"
            className="w-32 text-center bg-transparent border-none text-3xl font-bold text-white focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />

          <button
            onClick={handleIncrement}
            className="w-14 h-14 max-md:w-10 max-md:h-8 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center transition-all hover:scale-110"
          >
            <FontAwesomeIcon icon={faPlus} className="text-xl text-white" />
          </button>
        </div>
      </div>

      {/* Amount Summary */}
      <div className="px-6 mt-10 space-y-5 text-lg max-md:-mt-5">
        <div className="flex justify-between">
          <span className="text-gray-400">Subtotal</span>
          <span className="text-white font-semibold">${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">Platform Fee ({appSetUpData?.platform_percent || 0}%)</span>
          <span className="text-white font-semibold">${fee.toFixed(2)}</span>
        </div>
        <div className="flex justify-between pt-5 border-t border-gray-800">
          <span className="text-xl font-bold text-white">Total Required</span>
          <span className="text-2xl font-extrabold text-blue-400">${total.toFixed(2)}</span>
        </div>
      </div>

      {/* Error */}
      {tradeError && (
        <div className="px-6 mt-6 text-red-400 text-center font-medium text-lg">{tradeError}</div>
      )}

      {/* Confirm Button */}
      <div className="px-6 mt-10 pb-10 max-md:mt-1 max-md:flex max-md:justify-center max-md:items-center">
        <button
          onClick={() => {
            if (!signin) return navigate("/login");
            activeBtn === "Market" ? submitMarket() : submitPendingOrder();
          }}
          disabled={isLoading || quantity < 0.01 || !quantity}
          className={`w-full py-6 max-md:py-1 max-md:text-lg max-md:w-fit max-md:px-5 max-md:rounded-lg  rounded-2xl font-extrabold text-2xl transition-all duration-300 shadow-2xl
            ${buyOrSale === "buy" 
              ? "bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400" 
              : "bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400"}
            ${isLoading || quantity < 0.01 || !quantity ? "opacity-70 cursor-not-allowed" : "hover:scale-105 active:scale-95"}
          `}
        >
          {isLoading ? "Processing..." : `CONFIRM ${buyOrSale?.toUpperCase()}`}
        </button>
      </div>
    </div>
  );
};

export default Right_End_Toolbar;